export default {
  SET_USER(state, data) {
    state.user = data;
  }
};
